import { merge } from "lodash";
import React, { Component, useMemo, useState } from "react";
import {
    getInitLayoutConfig,
    useHtmlClassService
} from "../../../../_metronic/layout";
import { NoticeRekapitulasi } from "../../../../_metronic/_partials/controls";
import BelumMengisi from "./component/BelumMengisi";
import Detail from "./component/Detail";

const localStorageActiveTabKey = "rekapDetailActiveTab";

export function TabsStandarSPMI(params) {
  const activeTab = localStorage.getItem(localStorageActiveTabKey);
  const [key, setKey] = useState(activeTab ? +activeTab : 0);
  const [isLoading, setIsLoading] = useState(false);
  const htmlClassService = useHtmlClassService();
  const initialValues = useMemo(
    () =>
      merge(
        // Fulfill changeable fields.
        getInitLayoutConfig(),
        htmlClassService.config
      ),
    [htmlClassService.config]
  );

  const saveCurrentTab = (_tab) => {
    localStorage.setItem(localStorageActiveTabKey, _tab);
  };
  return (
    <>
      <NoticeRekapitulasi style={{ marginBottom: "0px", boxShadow: "none" }}>
        <strong style={{ fontSize: "18px" }}>Detail Rekapitulasi</strong>
        <p>Rekap Pelaporan SPMI</p>
      </NoticeRekapitulasi>
      <br />
      <div className="card card-custom">
        <div
          className="card-header card-header-tabs-line"
          style={{ minHeight: "50px" }}
        >
          <ul
            className="nav nav-dark nav-bold nav-tabs nav-tabs-line"
            data-remember-tab="tab_id"
            role="tablist"
          >
            <li className="nav-item">
              <a
                className={`nav-link ${key === 0 ? "active" : ""} py-5`}
                data-toggle="tab"
                onClick={() => {
                  setKey(0);
                  saveCurrentTab(0);
                }}
              >
                Detail
              </a>
            </li>
            <li className="nav-item">
              <a
                className={`nav-link ${key === 1 ? "active" : ""} py-5`}
                data-toggle="tab"
                onClick={() => {
                  setKey(1);
                  saveCurrentTab(1);
                }}
              >
                Perguruan Tinggi Yang Belum Mengisi
              </a>
            </li>
          </ul>
        </div>
        <div className="form">
          <div className="card-body">
            <div className="tab-content">
              <div className={`tab-pane ${key === 0 ? "active" : ""}`}>
                <Detail />
              </div>
              <div className={`tab-pane ${key === 1 ? "active" : ""}`}>
                <BelumMengisi />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
class RekapitulasiLembaga extends Component {
  render() {
    localStorage.setItem(localStorageActiveTabKey, 0);
    return (
      <>
        <TabsStandarSPMI />
      </>
    );
  }
}
export default RekapitulasiLembaga;
